import { type FieldValues, useController } from 'react-hook-form';
import type { DatepickerValue } from '../Datepicker/Datepicker.types';
import { DatepickerField } from '../DatepickerField/DatepickerField';
import type { DatepickerFieldProps } from '../DatepickerField/DatepickerField.types';
import type {
  FormControlProps,
  TypedUseControllerProps,
} from '../FormControl/FormControl.types';

export type FormDatepickerProps<
  TFieldValues extends FieldValues = FieldValues,
> = TypedUseControllerProps<TFieldValues, DatepickerValue> &
  FormControlProps<DatepickerFieldProps>;

export const FormDatepicker = <TFieldValues extends FieldValues = FieldValues>({
  disabled,
  ...props
}: FormDatepickerProps<TFieldValues>) => {
  const {
    field: { ref, ...field },
    formState: { errors },
  } = useController(props);

  const error = errors[props.name]?.message?.toString();

  return (
    <DatepickerField
      {...props}
      {...field}
      disabled={disabled}
      error={error}
      inputRef={ref}
    />
  );
};
